export default "__VITE_ASSET__SVzEJVPd__"